export const locales = {
	label: 'Je me connecte sur :',
	listLabel: 'Je choisis une structure :'
};
